<template>
<div>
  <h3 class="page-header">About Us</h3>
  <div class="row margin-top-40">
    <div class="col-12 col-md-6">
      <div class="content-width">
        <p>Hidden from the main road, we are conveniently located right in the middle of the North Fork Wine Country. Opened in 2008, The Red Rooster Bistro is decorated in a relaxed French country setting. </p>
        <p>Chef/Owner Nick Nikolov offers traditional French and American cuisine, with some Bulgarian dishes added for good measure.</p>
        <p>An international bistro, the Red Rooster offers traditional French - American and some Bulgarian recipes as well.</p>
      </div>
    </div>
    <div class="col-12 col-md-6 about-us content-width">
      <h5 class="bold">Owner/Chef</h5>
      <p>Nick Nikolov</p>
      <h5 class="bold margin-top">Year Established</h5>
      <p>2008</p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'About',
  metaInfo: {
    title: 'Red Rooster Bistro',
    titleTemplate: '%s | About',
    meta: [
      {
        name: 'description',
        content: 'View about us - Quiet French-American bistro in the heart of the North Fork\'s wine country.'
      }
    ]
  }
}
</script>

<style scoped>
.content-width {
  max-width: 400px;
}

.margin-top {
  margin-top: 20px;
}

.margin-top-40 {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue